export default __webpack_public_path__ + "static/competition-modal-header-43babb6417a9a29b15964613950d7669.png";